<template>
  <asc-container class="asc-user-profile-template">
    <asc-user-profile-info :user-profile="userProfile" />
  </asc-container>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscUserProfileInfo from '@/components/molecules/AscUserProfileInfo'

export default {
  name: 'AscUserProfileTemplate',

  components: {
    AscContainer,
    AscUserProfileInfo,
  },

  props: {
    userProfile: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
.asc-user-profile-template {
  height: calc(100vh - 120px);

  & .asc-container--headerWrapper {
    padding: 5px !important;
  }
}
</style>
